import React, { useEffect, useRef, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Opcao } from './comum'

interface Props {
  rotulo: string
  dica: string
  /** Quem procura: recebe o que foi digitado e devolve as opções. */
  buscar: (termo: string) => Promise<Opcao[]>
  /** Menos letras que isso e nem procura (a lista de ambientes aparece inteira com 0). */
  minimo?: number
  valor: Opcao[]
  aoMudar: (valor: Opcao[]) => void
  /** Só uma escolha: a nova troca a anterior. */
  unico?: boolean
  desabilitado?: boolean
}

/** Campo de busca com escolha de uma ou várias opções, que aparecem como etiquetas abaixo do campo. */
export default function CampoBusca({ rotulo, dica, buscar, minimo = 2, valor, aoMudar, unico, desabilitado }: Props) {
  const [termo, setTermo] = useState('')
  const [opcoes, setOpcoes] = useState<Opcao[]>([])
  const [aberto, setAberto] = useState(false)
  const [procurando, setProcurando] = useState(false)
  const pedido = useRef(0)
  // A função de busca costuma ser criada a cada render do formulário: a ref evita refazer a busca à toa.
  const buscarRef = useRef(buscar)
  buscarRef.current = buscar

  useEffect(() => {
    if (!aberto || termo.trim().length < minimo) { setOpcoes([]); return }
    const meu = ++pedido.current
    setProcurando(true)
    const t = setTimeout(async () => {
      let achadas: Opcao[] = []
      try { achadas = await buscarRef.current(termo.trim()) } catch { achadas = [] }
      if (meu === pedido.current) { setOpcoes(achadas); setProcurando(false) }
    }, 250)
    return () => clearTimeout(t)
  }, [termo, aberto, minimo])

  const escolher = (o: Opcao) => {
    if (unico) aoMudar([o])
    else if (!valor.some(v => v.id === o.id)) aoMudar([...valor, o])
    setTermo('')
    setOpcoes([])
    if (unico) setAberto(false)
  }
  const tirar = (id: number) => aoMudar(valor.filter(v => v.id !== id))
  const livres = opcoes.filter(o => !valor.some(v => v.id === o.id))
  const mostrar = aberto && termo.trim().length >= minimo

  return (
    <div className="ng-campo sol-busca">
      <span>{rotulo}</span>
      <input
        value={termo}
        onChange={e => { setTermo(e.target.value); setAberto(true) }}
        onFocus={() => setAberto(true)}
        onBlur={() => setTimeout(() => setAberto(false), 150)}
        placeholder={unico && valor.length ? 'Trocar a escolha…' : dica}
        aria-label={rotulo}
        autoComplete="off"
        disabled={desabilitado}
      />
      {mostrar && (
        <div className="sol-opcoes" role="listbox">
          {procurando && <div className="sol-opcao vazio">Procurando…</div>}
          {!procurando && livres.length === 0 && <div className="sol-opcao vazio">Nada encontrado.</div>}
          {livres.map(o => (
            <button type="button" key={o.id} role="option" aria-selected={false} className="sol-opcao" onMouseDown={e => e.preventDefault()} onClick={() => escolher(o)}>
              <b>{o.nome}</b>{o.detalhe && <small>{o.detalhe}</small>}
            </button>
          ))}
        </div>
      )}
      {valor.length > 0 && (
        <div className="sol-etiquetas">
          {valor.map(v => (
            <span key={v.id} className="sol-etiqueta">{v.nome}
              <button type="button" onClick={() => tirar(v.id)} aria-label={`Tirar ${v.nome}`}><CloseIcon fontSize="inherit" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
